import { render } from "./GridBody.vue?vue&type=template&id=c1ab9494&scoped=true&ts=true"
import script from "./GridBody.vue?vue&type=script&lang=ts"
export * from "./GridBody.vue?vue&type=script&lang=ts"

import "./GridBody.vue?vue&type=style&index=0&id=c1ab9494&lang=scss&scoped=true"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1ab9494"]])

export default __exports__